var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.175 1.41387C27.7109 -0.486107 30.4112 -0.465731 30.9184 1.44211L34.2785 14.0826C35.5303 18.7917 39.2083 22.4697 43.9174 23.7215L56.5579 27.0816C58.4657 27.5888 58.4861 30.2891 56.5861 30.825L43.9675 34.3841C39.4187 35.6671 35.8636 39.2221 34.5806 43.771L30.9661 56.5861C30.4344 58.4713 27.7622 58.4713 27.2305 56.5861L23.6159 43.771C22.3329 39.2221 18.7779 35.6671 14.229 34.3841L1.41386 30.7695C-0.471284 30.2378 -0.47129 27.5656 1.41386 27.0339L14.229 23.4194C18.7779 22.1364 22.3329 18.5813 23.6159 14.0325L27.175 1.41387Z",
    fill: "#46428F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.5c25080f8b838496fbc51e43bc3e616b.svg";
export { ForwardRef as ReactComponent };